export const ScreenSize = {
  xs: 0,
  sm: 600,
  md: 600,
  lg: 1200,
  xl: 1536,
};
